var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"payroll-component"}},[_c('highcharts',{attrs:{"constructor-type":'ganttChart',"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }